import { api, apiDelete, apiPost, apiPut } from '@/api/client'
import type { CashTerminal, CashTerminalForm } from './types'

export async function fetchStoreTerminals(
  storeId: string | number,
  archived: boolean,
  opts?: { fresh?: boolean },
): Promise<CashTerminal[]> {
  const params = new URLSearchParams()
  params.set('archived', archived ? '1' : '0')
  if (opts?.fresh) params.set('fresh', '1')
  const data = await api<{ terminals?: CashTerminal[] } | CashTerminal[]>(
    `/api/stores/${storeId}/terminals?${params.toString()}`,
  )
  return Array.isArray(data) ? data : data.terminals || []
}

export async function enrichTerminalsMeta(
  storeId: string | number,
  terminalIds: (string | number)[],
): Promise<CashTerminal[]> {
  const data = await api<{ terminals?: CashTerminal[] }>(
    `/api/stores/${storeId}/terminals/enrich-meta`,
    { method: 'POST', body: { terminalIds } },
  )
  return data.terminals || []
}

export async function createTerminal(body: CashTerminalForm): Promise<void> {
  await apiPost('/api/settings/terminals', body)
}

export async function updateTerminal(id: string | number, body: CashTerminalForm): Promise<void> {
  await apiPut(`/api/settings/terminals/${id}`, body)
}

export async function archiveTerminal(id: string | number): Promise<void> {
  await apiPost(`/api/settings/terminals/${id}/archive`)
}

export async function restoreTerminal(id: string | number): Promise<void> {
  await apiPost(`/api/settings/terminals/${id}/restore`)
}

export async function deleteTerminalPermanent(id: string | number): Promise<void> {
  await apiDelete(`/api/settings/terminals/${id}`)
}

export async function forceDeleteTerminal(id: string | number): Promise<void> {
  await apiDelete(`/api/settings/terminals/${id}/force`)
}
